<script>
import Layout from "@/views/layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import sg_sstAPI from "@/services/sg-sst/sg_sstAPI";
import UserSSOAPI from "@/services/sso/users/userSSOAPI";
import EmployeeAPI from "@/services/employee/employeeAPI";
import uploadDocument from "@/utils/digitalOcean/digitalocean-upload-file";
import Swal from "sweetalert2";
import { required } from "vuelidate/lib/validators";
import CheckModal from "@/components/CheckModal";
import LogTable from "@/components/standard/ResponsibleSGSST/ResponsibleLogTable";
import Table from "@/components/standard/ResponsibleSGSST/components/ResponsibleTable";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI";
import newScoresAPI from "../../../services/newScores/newScoresAPI";
import { sendNotification } from "@/utils/helpers/notification";
import ItemAPI from "@/services/items/itemsAPI";

export default {
  page: {
    title: "Responsable del SG SST",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
    LogTable,
    Table,
    CheckModal,
  },
  data() {
    return {
      title: "1.1.1 Responsable del SG SST",
      items: [
        {
          text: "Estándares",
          href: "/forms/estandares",
        },
        {
          text: "Responsable del SG SST",
          active: true,
        },
      ],

      submitted: false,

      sgsst: null,
      companies_id: null,
      puntation_relative: null,
      puntation_absoluta: null,
      items_id: null,

      role: 2,

      itemData: null,

      item1: null,
      itemStatus1: null,

      item11: null,
      itemStatus11: null,

      item41: null,
      itemStatus41: null,

      sg_sstData: {
        id: null,
        id_diseno_sso: null,
        employee: null,
        appointment_date: null,
        withdrawal_date: null,
        status: false,
        company_name: null,
        course_start_date: null,
        certificate: null,
        professional_name: null,
        professional_license_number: null,
        professional_license: null,
        professional_course_50h_certificate: null,
        professional_course_50h_date: null,
        professional_course_20h_certificate: null,
        professional_course_20h_date: null,
        course_20h_certificate: null,
        course_20h_date: null,
        designation_acta: null,
        professional_designation_acta: null,
      },

      userSelected: null,
      usersList: [],

      list: [],

      employeeDesignSST: "",

      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      company: this.$store.getters["company/getCompany"] || null,
      user: this.$store.state.auth || null,

      file: null,
      licenseFile: null,
      course20hFile: null,
      // Actas de designación diligenciadas que sube la empresa (alternativa al acta
      // que la app genera y firma digitalmente desde la pantalla de edición).
      operativoActaFile: null,
      profesionalActaFile: null,
      profCourse50hFile: null,
      profCourse20hFile: null,
      // Formatos descargables (bucket /standards) de las actas de designación.
      formatos: {
        operativo: "ACTA_DESIGNACION_RESPONSABLE_OPERATIVO_SGSST.docx",
        profesional: "ACTA_DESIGNACION_RESPONSABLE_SGSST.docx",
      },
      loading: true,
      guardando: false,
      loading2: true,
    };
  },
  validations: {
    sg_sstData: {
      employee: {
        required,
      },
      appointment_date: {
        required,
      },
    },
  },
  methods: {
    /**
     *This method get the item data.
     */
    getItemData() {
      ItemAPI.getItems(1)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    /**
     * This method indicates whether the company has a classification corresponding to
     * the permit for the item in question.
     * @param {JSON} item The item object.
     */
    allowAccess() {
      try {
        const item = this.itemData;
        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"]
              .company_classification_id || null;
          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    /**
     * This method is used to send notification to SST user and SST company.
     * The sendNotification method import is required.
     * @param {Number} messageID - The message ID that will be associated to notification.
     * @param {Number} itemID - The item ID that will be associated to notification.
     * @param {Boolean} user - The user that will e associated to notification.
     * @return {Boolean} True if the notification is sent, false if not.
     */
    sendNotification(messageID, itemID, user) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(company.id, user ? company.id_diseno_sso : null, messageID, itemID);
    },

    /**
     * This method is used to knows if the user has the permission indicated
     * @param {String} name The name of the permission
     * @param {Array} roles the roles that permitted to access the action
     * @returns {Boolean} true if the user has the permission indicated or false if no
     */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role
        ? this.$store.state.auth.info.role
        : null;
      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false;
        } // Close if the roles arrays is not empty
        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role =
            role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8;
        } // Close if the roles arrays is empty
        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions;
        // Know if the user has the permission indicated
        const enabled = permissions.find(
          (permission) => permission.name === name
        );
        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false;
      } // Close if the user is logged
      // If the user is not logged
      else {
        return false;
      } // Close else the user is not logged
    },

    getFile(file) {
      if (!file) return "";
      const name = file.split("/");
      return name[name.length - 1];
    },

    /** Descarga el formato del acta de designación desde el bucket (carpeta /standards). */
    downloadFormato(filename) {
      const url = `${process.env.VUE_APP_BUCKET}/standards/${filename}`;
      window.open(url, "_blank");
    },

    changeStatusValue() {
      this.sg_sstData.status = !this.sg_sstData.status;
    },

    async uploadFile() {
      this.file = this.$refs.file.files[0];
    },

    async uploadDocument() {
      try {
        let url = "";
        let name = '';

        if (this.file === null) {
          name = this.getFile(this.sg_sstData.certificate)
        } else {
          name = this.file.name
        }

        if (process.env.VUE_APP_ENV === 'development') {
          url = `sst-dev/${this.company.nit}/1.1.1/${this.sg_sstData.employee.id}/${name}`;
        } else {
          url = `sst-prod/${this.company.nit}/1.1.1/${this.sg_sstData.employee.id}/${name}`;
        }

        if (this.file === null) {
          return true;
        } else {
          const result = await uploadDocument(url, this.file);
          if (result) {
            this.sg_sstData.certificate = `${process.env.VUE_APP_BUCKET}/${url}`;
            return true;
          } else return false;
        }
      } catch (error) {
        console.log(error);
      }
    },

    /**
     * Sube un archivo al bucket bajo la carpeta del ítem 1.1.1 del empleado operativo
     * y devuelve la URL pública, o null si falla.
     */
    async uploadToBucket(file, filename) {
      const employeeId = this.sg_sstData.employee && this.sg_sstData.employee.id;
      const env = process.env.VUE_APP_ENV === 'development' ? 'sst-dev' : 'sst-prod';
      const path = `${env}/${this.company.nit}/1.1.1/${employeeId}/${filename}`;
      const ok = await uploadDocument(path, file);
      return ok ? `${process.env.VUE_APP_BUCKET}/${path}` : null;
    },

    /**
     * Sube los documentos externos del profesional (licencia) y el certificado de 20h.
     */
    async uploadExtraDocs() {
      try {
        if (this.licenseFile) {
          const url = await this.uploadToBucket(this.licenseFile, `licencia-${this.licenseFile.name}`);
          if (url) this.sg_sstData.professional_license = url;
        }
        if (this.course20hFile) {
          const url = await this.uploadToBucket(this.course20hFile, `op-curso20h-${this.course20hFile.name}`);
          if (url) this.sg_sstData.course_20h_certificate = url;
        }
        if (this.profCourse50hFile) {
          const url = await this.uploadToBucket(this.profCourse50hFile, `prof-curso50h-${this.profCourse50hFile.name}`);
          if (url) this.sg_sstData.professional_course_50h_certificate = url;
        }
        if (this.profCourse20hFile) {
          const url = await this.uploadToBucket(this.profCourse20hFile, `prof-curso20h-${this.profCourse20hFile.name}`);
          if (url) this.sg_sstData.professional_course_20h_certificate = url;
        }
        if (this.operativoActaFile) {
          const url = await this.uploadToBucket(this.operativoActaFile, `acta-operativo-${this.operativoActaFile.name}`);
          if (url) this.sg_sstData.designation_acta = url;
        }
        if (this.profesionalActaFile) {
          const url = await this.uploadToBucket(this.profesionalActaFile, `acta-profesional-${this.profesionalActaFile.name}`);
          if (url) this.sg_sstData.professional_designation_acta = url;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async save() {
      try {
        this.guardando = true;
        this.loading = true;
        let response = false
        // Snapshot del profesional + carga de licencia y certificado de 20h (independientes del curso 50h)
        this.sg_sstData.professional_name = this.employeeDesignSST
          ? (this.employeeDesignSST.name || this.employeeDesignSST.full_name || null)
          : null;
        await this.uploadExtraDocs();
        if (this.sg_sstData.status === true) {
          response = await this.uploadDocument();
          if (response) {
            let data = {
              employee_id: this.sg_sstData.employee.id,
              id_diseno_sso: this.employeeDesignSST.id,
              appointment_date: this.sg_sstData.appointment_date,
              withdrawal_date: this.sg_sstData.withdrawal_date,
              status: true,
              company_name: this.sg_sstData.company_name,
              companies_id: this.$store.getters["company/getCompany"].id,
              course_start_date: this.sg_sstData.course_start_date,
              certificate: this.sg_sstData.certificate,
              professional_name: this.sg_sstData.professional_name,
              professional_license_number: this.sg_sstData.professional_license_number,
              professional_license: this.sg_sstData.professional_license,
              professional_course_50h_certificate: this.sg_sstData.professional_course_50h_certificate,
              professional_course_50h_date: this.sg_sstData.professional_course_50h_date,
              professional_course_20h_certificate: this.sg_sstData.professional_course_20h_certificate,
              professional_course_20h_date: this.sg_sstData.professional_course_20h_date,
              course_20h_certificate: this.sg_sstData.course_20h_certificate,
              course_20h_date: this.sg_sstData.course_20h_date,
              designation_acta: this.sg_sstData.designation_acta,
              professional_designation_acta: this.sg_sstData.professional_designation_acta,
            };
            sg_sstAPI.createSg_sst(data)
              .then((response) => {
                this.sg_sstData.employee.implementation_status = 1;
                EmployeeAPI.updateEmployee(this.sg_sstData.employee)
                  .then((res) => {
                    const itemChange11 = {
                      companies_id: this.companyID,
                      item_id: 1,
                      status: 'Pendiente',
                    };
                    newScoresAPI.calculateScores(itemChange11)
                      .then((response) => {
                        const itemChange41 = {
                          companies_id: this.companyID,
                          item_id: 11,
                          status: 'Pendiente',
                        };
                        newScoresAPI.calculateScores(itemChange41)
                          .then((response) => {
                            this.loading = false
                            setTimeout(() => {
                              Swal.fire({
                                title: "¡Éxito!",
                                text: "¡Se ha registrado con éxito!",
                                type: "success",
                                icon: "success",
                                confirmButtonClass: "btn btn-confirm mt-2",
                              });
                              this.$router.go(-1);
                            }, 2000)
                          })
                          .catch((error) => {
                            Swal.fire({
                              title: "¡ERROR!",
                              text: "¡No se ha actualizado el estado del ítem!",
                              icon: "error",
                              type: "error",
                              confirmButtonClass: "btn btn-confirm mt-2",
                            });
                            setTimeout(() => window.location.reload(), 2000)
                            console.log(error);
                          });
                      })
                      .catch((error) => {
                        Swal.fire({
                          title: "¡ERROR!",
                          text: "¡No se ha actualizado el estado del ítem!",
                          icon: "error",
                          type: "error",
                          confirmButtonClass: "btn btn-confirm mt-2",
                        });
                        setTimeout(() => window.location.reload(), 2000)
                        console.log(error);
                      });
                  })
                  .catch((error) => {
                    console.log('employee error', error);
                  });
              })
              .catch((error) => {
                console.log(error);
              });
          }
        } else {
          let data = {
            employee_id: this.sg_sstData.employee.id,
            id_diseno_sso: this.employeeDesignSST.id,
            appointment_date: this.sg_sstData.appointment_date,
            withdrawal_date: this.sg_sstData.withdrawal_date,
            status: true,
            company_name: this.sg_sstData.company_name,
            companies_id: this.$store.getters["company/getCompany"].id,
            course_start_date: this.sg_sstData.course_start_date,
            certificate: this.sg_sstData.certificate,
            professional_name: this.sg_sstData.professional_name,
            professional_license_number: this.sg_sstData.professional_license_number,
            professional_license: this.sg_sstData.professional_license,
            professional_course_50h_certificate: this.sg_sstData.professional_course_50h_certificate,
            professional_course_50h_date: this.sg_sstData.professional_course_50h_date,
            professional_course_20h_certificate: this.sg_sstData.professional_course_20h_certificate,
            professional_course_20h_date: this.sg_sstData.professional_course_20h_date,
            course_20h_certificate: this.sg_sstData.course_20h_certificate,
            course_20h_date: this.sg_sstData.course_20h_date,
            designation_acta: this.sg_sstData.designation_acta,
            professional_designation_acta: this.sg_sstData.professional_designation_acta,
          };
          sg_sstAPI.createSg_sst(data)
            .then((response) => {
              this.sg_sstData.employee.implementation_status = 1;
              EmployeeAPI.updateEmployee(this.sg_sstData.employee)
                .then((res) => {
                  this.loading = false
                  setTimeout(() => {
                    Swal.fire({
                      title: "¡Éxito!",
                      text: "¡Se ha registrado con éxito!",
                      type: "success",
                      icon: "success",
                      confirmButtonClass: "btn btn-confirm mt-2",
                    });
                    this.$router.go(-1);
                  }, 2000)
                })
                .catch((error) => {
                  console.log('employee error', error);
                });
            })
            .catch((error) => {
              console.log(error);
            });
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getUsers() {
      try {
        const { data } = await UserSSOAPI.getAllAdmin();
        const users = data;
        if (users && users.length > 0) {
          let designUser = users.find(
            (item) => item.id == this.company.id_diseno_sso
          );
          this.employeeDesignSST = designUser;
        }

        const { employee } = await EmployeeAPI.getAll(this.companyID);

        const list = employee.filter((item) => item.id_implementation_sso);

        this.usersList = list || null;
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    goBack() {
      this.$router.go(-1);
    },

    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 1)
        .then((response) => {
          this.item1 = response !== {} ? response : null;
          this.itemStatus1 = response.status ? response.status : null;
        })
        .catch((error) => {
          console.log(error);
        });

      CompanyItemsAPI.getStatus(this.companyID, 11)
        .then((response) => {
          this.item11 = response !== {} ? response : null;
          this.itemStatus11 = response.status ? response.status : null;
        })
        .catch((error) => {
          console.log(error);
        });

      this.loading2 = false;
    },
  },

  mounted() {
    this.getUsers();
    this.getItems();
    this.getItemData();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12">

        <div v-if="!loading && !loading2 && classificationID <= 4">
          <div class="card">

            <div class="card-body">
              <div class="row">

                <div class="col-md-6 col-sm-12">

                  <CheckModal>
                    <p class="text-justify">
                      Como responsable del SG-SST van a existir dos roles:
                    </p>
                    <p class="text-justify">
                      <b>Profesional Responsable del SG-SST:</b> Se nombrará por parte de Emisión, será el encargado de guiar todo el
                      proceso de diseño de la implementación de SG-SST.
                    </p>
                    <p class="text-justify">
                      <b>Responsable operativo del SG-SST:</b> Persona por parte de la Empresa que será la encargada de
                      llevar
                      a
                      cabo las actividades correspondientes, recopilar las evidencias y alimentar el sistema con estos
                      archivos para poder hacer seguimiento a las actividades de implementación por parte del
                      Profesional Responsable del SG-SST.
                    </p>
                    <hr />
                    <p class="text-justify">
                      <b>Funciones:</b>
                    </p>
                    <p class="text-justify">
                    <ol>
                      <li>
                        Planificar, dirigir, ejecutar y aplicar el SG-SST.
                      </li>
                      <li>
                        Informar a la gerencia sobre el funcionamiento y resultados del SG-SST.
                      </li>
                      <li>
                        Promover la participación de los miembros de la empresa en la implementación del SG-SST.
                      </li>
                      <li>
                        Promover la comprensión de la política en todas las áreas de la empresa.
                      </li>
                      <li>
                        Coordinar las capacitaciones necesarias en materia de prevención.
                      </li>
                      <li>
                        Apoyar la investigación de accidentes de trabajo.
                      </li>
                      <li>
                        Apoyar las reuniones de los diferentes comités conformados.
                      </li>
                      <li>
                        Implementación, seguimiento y control del SG-SST.
                      </li>
                    </ol>
                    </p>
                  </CheckModal>
                </div>

              </div>

              <form calss="form-group" @submit.prevent="save">
                <div class="form-row pt-3">

                  <b-form-group class="col-md-6 px-2" label="Profesional Responsable del SG-SST" label-for="designResponsible">
                    <b-form-input type="text" id="designResponsible" placeholder="" v-model="employeeDesignSST.name"
                      disabled>
                    </b-form-input>
                  </b-form-group>

                  <b-form-group id="responsibleSST" label-for="responsibleSST" class="col-md-6 px-2"
                    label="Responsable operativo del SG-SST">

                    <select
                      :disabled="!getRole('Crear') || !getRole('Asignar responsable de implemenación') || !allowAccess()"
                      class="form-control" v-model="sg_sstData.employee"
                      :class="{ 'is-invalid': $v.sg_sstData.employee.$error && submitted }">
                      <b-form-select-option v-for="item in usersList" :key="item.id" :value="item">
                        {{ item.full_name }}
                      </b-form-select-option>
                    </select>

                    <a id="responsibleText" underline href="/forms/sg-sst"><small>¿Quién es el responsable operativo?</small></a>
                    <div v-if="submitted && $v.sg_sstData.employee.$error">
                      <small v-if="!$v.sg_sstData.employee.required" class="text-danger">
                        <b>El responsable operativo del SG-SST es requerido
                        </b>
                      </small>
                    </div>
                  </b-form-group>

                </div>

                <div class="form-row">

                  <b-form-group class="col-md-6 px-2" label="Fecha nombramiento" label-for="appintmentDate">

                    <b-form-input
                      :disabled="!getRole('Crear') || !getRole('Asignar responsable de implemenación') || !allowAccess()"
                      type="date" id="appointmentDate" v-model="sg_sstData.appointment_date"
                      :class="{ 'is-invalid': $v.sg_sstData.appointment_date.$error && submitted }">
                    </b-form-input>
                    <div v-if="submitted && $v.sg_sstData.appointment_date.$error">
                      <small v-if="!$v.sg_sstData.appointment_date.required" class="text-danger">
                        <b>La fecha de nombramiento es requerida
                        </b>
                      </small>
                    </div>
                  </b-form-group>


                  <b-form-group class="col-md-6 px-2" label="Fecha retiro" label-for="withdrawalDate">

                    <b-form-input
                      :disabled="!getRole('Crear') || !getRole('Asignar responsable de implemenación') || !allowAccess()"
                      type="date" id="withdrawalDate" v-model="sg_sstData.withdrawal_date">

                    </b-form-input>
                  </b-form-group>
                </div>

                <div class="row px-2">
                  <div class="col-md-2 col-sm-12">
                    <div class="form-row m-0">
                      <b-form-group class="pt-3 mb-0" label="¿El operativo tiene el curso de 50 horas?" label-for="course">
                      </b-form-group>

                      <b-form-group class="col-sm-12" label-for="course">
                        <a id="course" underline href="/forms/curso#list-item-2"><small>¿Dónde
                            puedo hacer el
                            curso?</small></a>

                      </b-form-group>
                    </div>
                  </div>

                  <div class="col-md-3 col-sm-12">
                    <div class="form-row">
                      <b-form inline class="pt-3 float-left">
                        <label class="mr-2">
                          Si
                        </label>
                        <input
                          :disabled="!getRole('Crear') || !getRole('Asignar responsable de implemenación') || !allowAccess()"
                          type="radio" style="color: #666" @click="changeStatusValue" v-model="sg_sstData.status"
                          :value="true" class="mb-2 mr-sm-2 mb-sm-0" label="Si" />
                        <label class="mr-2 pl-sm-2 pl-md-0">
                          No
                        </label>
                        <input
                          :disabled="!getRole('Crear') || !getRole('Asignar responsable de implemenación') || !allowAccess()"
                          type="radio" @click="changeStatusValue" v-model="sg_sstData.status" :value="false"
                          class="mb-2 mr-sm-2 mb-sm-0" label="No" />
                      </b-form>
                    </div>
                  </div>

                  <div class="col-6 pt-1"></div>
                </div>

                <div class="form-row pt-1" v-if="sg_sstData.status">
                  <div class="col-md-4 col-sm-12 px-2">

                    <b-form-group label="Fecha" label-for="dateCourse">

                      <b-form-input
                        :disabled="!getRole('Crear') || !getRole('Asignar responsable de implemenación') || !allowAccess()"
                        required type="date" id="courseStartDate" v-model="sg_sstData.course_start_date"
                        :class="{ 'is-invalid': sg_sstData.course_start_date === null && submitted }">
                      </b-form-input>
                      <div v-if="submitted && sg_sstData.course_start_date === null">
                        <small v-if="sg_sstData.course_start_date === null" class="text-danger">
                          <b>La fecha de realización del curso es requerida
                          </b>
                        </small>
                      </div>
                    </b-form-group>
                  </div>

                  <div class="col-md-4 col-sm-12 px-2">
                    <b-form-group label="Entidad certificadora" label-for="certificateLabel">

                      <b-form-input
                        :disabled="!getRole('Crear') || !getRole('Asignar responsable de implemenación') || !allowAccess()"
                        required type="text" placeholder="Entidad certificadora" id="certificateCompany"
                        v-model="sg_sstData.company_name">
                      </b-form-input>
                    </b-form-group>
                  </div>

                  <div class="col-md-4 col-sm-12 px-2">

                    <b-form-group label="Certificado" label-for="certificateFileLabel">

                      <b-form-file
                        :disabled="!getRole('Crear') || !getRole('Asignar responsable de implemenación') || !allowAccess()"
                        type="file" id="file" ref="file" name="file" browse-text="Buscar" required
                        :placeholder="sg_sstData.certificate ? getFile(sg_sstData.certificate) : `Selecciona un archivo...`"
                        drop-placeholder="Suelta acá..." v-model="file" @change="uploadFile" v-on:change="uploadFile"
                        accept=".doc,.pdf, .xlsx, .xls, .docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                        :class="{ 'is-invalid': sg_sstData.certificate === null && submitted }">
                      </b-form-file>
                      <div v-if="submitted && sg_sstData.certificate === null">
                        <small v-if="sg_sstData.certificate === null" class="text-danger">
                          <b>El certificado es requerido
                          </b>
                        </small>
                      </div>
                    </b-form-group>
                  </div>
                </div>

                <hr />
                <p class="pl-2 text-muted small mb-2">
                  Las actas de designación (responsable y operativo) se generan y firman automáticamente
                  desde la pestaña de edición. Aquí se cargan los documentos externos: licencia del
                  profesional y certificados de los cursos (50h y 20h) de cada persona.
                </p>

                <div class="d-flex align-items-center justify-content-between pl-2 mb-2 flex-wrap">
                  <h6 class="mb-0 font-weight-bold">Responsable Operativo — Curso 20 horas</h6>
                  <button type="button" class="btn btn-outline-primary btn-sm"
                    @click="downloadFormato(formatos.operativo)">
                    <i class="bx bx-download"></i> Descargar acta de designación
                  </button>
                </div>
                <div class="form-row pt-1">
                  <div class="col-md-3 col-sm-12 px-2">
                    <b-form-group label="Acta de designación diligenciada" label-for="opActaFile">
                      <b-form-file
                        :disabled="!getRole('Crear') || !getRole('Asignar responsable de implemenación') || !allowAccess()"
                        id="opActaFile" ref="operativoActaFile" browse-text="Buscar" v-model="operativoActaFile"
                        placeholder="Selecciona un archivo..." drop-placeholder="Suelta acá..."
                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png">
                      </b-form-file>
                    </b-form-group>
                  </div>
                  <div class="col-md-3 col-sm-12 px-2">
                    <b-form-group label="Fecha curso 20 horas" label-for="opCourse20hDate">
                      <b-form-input
                        :disabled="!getRole('Crear') || !getRole('Asignar responsable de implemenación') || !allowAccess()"
                        type="date" id="opCourse20hDate" v-model="sg_sstData.course_20h_date">
                      </b-form-input>
                    </b-form-group>
                  </div>
                  <div class="col-md-3 col-sm-12 px-2">
                    <b-form-group label="Certificado curso 20 horas" label-for="opCourse20hFile">
                      <b-form-file
                        :disabled="!getRole('Crear') || !getRole('Asignar responsable de implemenación') || !allowAccess()"
                        id="opCourse20hFile" ref="course20hFile" browse-text="Buscar" v-model="course20hFile"
                        placeholder="Selecciona un archivo..." drop-placeholder="Suelta acá..."
                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png">
                      </b-form-file>
                    </b-form-group>
                  </div>
                </div>

                <div class="d-flex align-items-center justify-content-between pl-2 mb-2 mt-2 flex-wrap">
                  <h6 class="mb-0 font-weight-bold">Profesional Responsable del SG-SST</h6>
                  <button type="button" class="btn btn-outline-primary btn-sm"
                    @click="downloadFormato(formatos.profesional)">
                    <i class="bx bx-download"></i> Descargar acta de designación
                  </button>
                </div>
                <div class="form-row pt-1">
                  <div class="col-md-3 col-sm-12 px-2">
                    <b-form-group label="Acta de designación diligenciada" label-for="profActaFile">
                      <b-form-file
                        :disabled="!getRole('Crear') || !getRole('Asignar responsable de implemenación') || !allowAccess()"
                        id="profActaFile" ref="profesionalActaFile" browse-text="Buscar" v-model="profesionalActaFile"
                        placeholder="Selecciona un archivo..." drop-placeholder="Suelta acá..."
                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png">
                      </b-form-file>
                    </b-form-group>
                  </div>
                  <div class="col-md-3 col-sm-12 px-2">
                    <b-form-group label="Licencia en SST N.°" label-for="licenseNumber">
                      <b-form-input
                        :disabled="!getRole('Crear') || !getRole('Asignar responsable de implemenación') || !allowAccess()"
                        type="text" id="licenseNumber" placeholder="N.° de licencia"
                        v-model="sg_sstData.professional_license_number">
                      </b-form-input>
                    </b-form-group>
                  </div>
                  <div class="col-md-3 col-sm-12 px-2">
                    <b-form-group label="Licencia (archivo)" label-for="licenseFile">
                      <b-form-file
                        :disabled="!getRole('Crear') || !getRole('Asignar responsable de implemenación') || !allowAccess()"
                        id="licenseFile" ref="licenseFile" browse-text="Buscar" v-model="licenseFile"
                        placeholder="Selecciona un archivo..." drop-placeholder="Suelta acá..."
                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png">
                      </b-form-file>
                    </b-form-group>
                  </div>
                </div>
                <div class="form-row pt-1">
                  <div class="col-md-3 col-sm-12 px-2">
                    <b-form-group label="Fecha curso 50 horas" label-for="profCourse50hDate">
                      <b-form-input
                        :disabled="!getRole('Crear') || !getRole('Asignar responsable de implemenación') || !allowAccess()"
                        type="date" id="profCourse50hDate" v-model="sg_sstData.professional_course_50h_date">
                      </b-form-input>
                    </b-form-group>
                  </div>
                  <div class="col-md-3 col-sm-12 px-2">
                    <b-form-group label="Certificado curso 50 horas" label-for="profCourse50hFile">
                      <b-form-file
                        :disabled="!getRole('Crear') || !getRole('Asignar responsable de implemenación') || !allowAccess()"
                        id="profCourse50hFile" ref="profCourse50hFile" browse-text="Buscar" v-model="profCourse50hFile"
                        placeholder="Selecciona un archivo..." drop-placeholder="Suelta acá..."
                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png">
                      </b-form-file>
                    </b-form-group>
                  </div>
                  <div class="col-md-3 col-sm-12 px-2">
                    <b-form-group label="Fecha curso 20 horas" label-for="profCourse20hDate">
                      <b-form-input
                        :disabled="!getRole('Crear') || !getRole('Asignar responsable de implemenación') || !allowAccess()"
                        type="date" id="profCourse20hDate" v-model="sg_sstData.professional_course_20h_date">
                      </b-form-input>
                    </b-form-group>
                  </div>
                  <div class="col-md-3 col-sm-12 px-2">
                    <b-form-group label="Certificado curso 20 horas" label-for="profCourse20hFile">
                      <b-form-file
                        :disabled="!getRole('Crear') || !getRole('Asignar responsable de implemenación') || !allowAccess()"
                        id="profCourse20hFile" ref="profCourse20hFile" browse-text="Buscar" v-model="profCourse20hFile"
                        placeholder="Selecciona un archivo..." drop-placeholder="Suelta acá..."
                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png">
                      </b-form-file>
                    </b-form-group>
                  </div>
                </div>

                <div class="form-group text-right m-b-0">
                  <button :disabled="guardando" type="submit" class="btn btn-primary">
                    Guardar
                  </button>
                  <button type="button" class="btn btn-secondary mx-1" @click="goBack">
                    Cancelar
                  </button>
                </div>

              </form>
            </div>
          </div>

        </div>

        <div v-else>
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>

      </div>
    </div>
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>